// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UserApiKeySettingsModel from '../../model/user-api-key-settings-model';
import UserApiKeySettingsDTO from '../dto/user-api-key-settings-dto';
import dtoSchema from '../schemas/user-api-key-settings-schema';

export default abstract class UserApiKeySettingsModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UserApiKeySettingsDTO>) {
    super();
    if (data) {
      this.apiKeyLength = data.apiKeyLength;
      this.apiKeyPrefix = data.apiKeyPrefix ?? undefined;
    }
  }
  /**
  * @type {int32}
  */
  apiKeyLength?: number;
  /**
  */
  apiKeyPrefix?: string;

  static toModel(dto: DeepPartial<UserApiKeySettingsDTO>): UserApiKeySettingsModel;
  static toModel(dto: DeepPartial<UserApiKeySettingsDTO> | undefined | null): UserApiKeySettingsModel | undefined;
  static toModel(dto: DeepPartial<UserApiKeySettingsDTO> | undefined | null): UserApiKeySettingsModel | undefined {
    return dto ? new UserApiKeySettingsModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UserApiKeySettingsModel> | UserApiKeySettingsModel): UserApiKeySettingsDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      apiKeyLength: unwrapped.apiKeyLength,
      apiKeyPrefix: unwrapped.apiKeyPrefix,
    } as UserApiKeySettingsDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UserApiKeySettingsModel, can not map to UserApiKeySettingsDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
